export const CONTACT_EMAIL = "todd2thenations@gmail.com";
export const ZELLE_EMAIL = "todd2thenations@gmail.com";

export const NAV_LINKS = [
  { label: "Mission", href: "#mission" },
  { label: "About", href: "#about" },
  { label: "Our Values", href: "#serve" },
  { label: "Contact", href: "#contact" },
];

export const IMAGES = {
  heroNature: "/hero-valley.webp",
  childrenCare:
    "https://images.unsplash.com/photo-1770914701481-b21f16a26123?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxoaXNwYW5pYyUyMGJveXMlMjBzbWlsaW5nJTIwZnJpZW5kcyUyMG91dGRvb3JzfGVufDB8fHx8MTc5MTQ5NjE5MHww&ixlib=rb-4.1.0&q=85",
  childrenCommunity:
    "https://images.unsplash.com/photo-1636320805687-7559c1192151?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxsYXRpbiUyMGFtZXJpY2FuJTIwY2hpbGRyZW4lMjBqb3lmdWwlMjBncm91cHxlbnwwfHx8fDE3OTE0OTUzNzd8MA&ixlib=rb-4.1.0&q=85",
  communityService:
    "https://images.unsplash.com/photo-1593113616828-6f22bca04804?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHx2b2x1bnRlZXJzJTIwc2VydmluZyUyMGNvbW11bml0eSUyMG1lYWwlMjBjYXJlfGVufDB8fHx8MTc5MTQ5MjUxMHww&ixlib=rb-4.1.0&q=85",
  mountainWater:
    "https://images.unsplash.com/photo-1533168461629-51f6f8061c68?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxtb3VudGFpbnMlMjBvY2VhbiUyMGxhbmRzY2FwZSUyMHBlYWNlZnVsfGVufDB8fHx8MTc5MTQ5MjUxMHww&ixlib=rb-4.1.0&q=85",
  handsTogether:
    "https://images.unsplash.com/photo-1697490251788-21888514f669?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxjaGlsZHJlbiUyMHJlZnVnZSUyMGNvbW11bml0eSUyMG1pbmlzdHJ5JTIwaG9wZSUyMHN1cHBvcnR8ZW58MHx8fHwxNzkxNDkyNTAyfDA&ixlib=rb-4.1.0&q=85",
};

export const SERVE_ITEMS = [
  {
    no: "01",
    icon: "Home",
    title: "A Safe, Loving Home",
    body: "Care for vulnerable children in a safe, loving, Christ-centered home.",
  },
  {
    no: "02",
    icon: "Compass",
    title: "Strength for the Sent",
    body: "Serve missionaries and ministry workers in difficult circumstances.",
  },
  {
    no: "03",
    icon: "HeartHandshake",
    title: "Hope for the Weary",
    body: "Encourage and equip Christians walking through discouraging seasons.",
  },
  {
    no: "04",
    icon: "Hammer",
    title: "Practical Service",
    body: "Support local communities through practical acts of service.",
  },
  {
    no: "05",
    icon: "BookOpen",
    title: "The Gospel, Shared",
    body: "Share the Gospel through genuine, lasting relationships.",
  },
  {
    no: "06",
    icon: "Sunrise",
    title: "Faith, Hope & Love",
    body: "Help people experience faith, hope, and love in tangible ways.",
  },
  {
    no: "07",
    icon: "Users",
    title: "Raising Up Others",
    body: "Raise up others to serve, rather than doing everything ourselves.",
  },
];
